<template>
	<div class="container">
		<div class="form__wrapper form__wrapper--no-border">
			<div class="form__body">
				<form @submit.prevent="createPost">
					<div class="form-row">
						<div class="col-md-12">
							<div class="form-group">
								<label for="title">Provide a Question Title</label>
								<input
									id="title"
									v-model="forumData.title"
									@keydown="clearErrors($event.target.name)"
									:class="[{ 'is-invalid': errors.title}]"
									class="form-control"
									placeholder="Enter a title here"
									type="text">
								<div class="invalid-feedback">
									{{ errors.title }}
								</div>
							</div>
						</div>
					</div>
					<div class="form-group">
						<!--<label for="category">Category</label>-->
						<input
								v-model="forumData.forum_category_id"
								class="form-control"
								placeholder="Enter category"
								type="hidden">

						<div class="invalid-feedback">
							{{ errors.forum_category_id }}
						</div>
					</div>

					<div class="form-row">
						<div class="col-md-12">
							<div class="form-group">
								<label for="forum-body">Ask a Question</label>
								<textarea
									id="forum-body"
									v-model="forumData.body"
									@keydown="clearErrors($event.target.name)"
									title=""
									:class="[{ 'is-invalid': errors.title}]"
									class="input input--lg input--light"
									cols="30"
									rows="4"
									placeholder="What do you need help with? please be specific,so that your peers are better able to assist you.">
								</textarea>
								<div class="invalid-feedback">
									{{ errors.body }}
								</div>
							</div>
						</div>
					</div>

					<div class="btn__group btn__group--form">
						<button
							@click.prevent="clearErrors"
							class="btn__grey">Cancel</button>
						<button
							@click.prevent="createPost"
							:v-bind="{'disabled': loading}"
							class="btn__primary btn__primary--lg">Publish discussion</button>
						<!--<span class="loader">-->
							<!--<loader v-if="loading"/>-->
						<!--</span>	-->
					</div>
				</form>
			</div>
		</div>
	</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import form from '../../mixins/form';
import forum from '../../utils/validations/forum';
import { getForumCategories } from '../../utils/api/forum';
import Loader from '../../components/Loader';

export default {
	name: 'CreateForumPost',
	mixins: [form],
	components: {
		Loader
	},
	data() {
		return {
			itemData:{},
			forumData: {
				title: '',
				body: '',
              	forum_category_id: 1,
			},
			errors: {},
			loading: false,
			loadingCategories: false,
			forumCategories: [],
			categoriesLoaded: true
		};
	},
	computed: {
		...mapGetters([
			'getPostStatus'
		])
	},
	watch: {
		getPostStatus(newValue) {
			this.loading = !!(newValue === 'loading');
			if (newValue === 'success') {
				this.$router.push('/forum');
			}
		}
	},
	created() {
		//this.listForumCategories();

		if (this.$session.get('category') === 'employer') {
			this.$router.push('/jobs');
		}
	},
	methods: {
		...mapActions([
			'postForumTopic'
		]),
		/**
		 * This creates a forum post
		 */
		createPost() {
			this.validate(this.itemData, forum.post);
			if (Object.keys(this.issues).length > 0) {
				this.errors = this.issues;
				return false;
			}
			this.loading = true;
			this.postForumTopic({ ...this.forumData, user_id: this.$session.get('id') });
			return true;
		},
		/**
		 * Fetches a list of all forum categories
		 */
		listForumCategories() {
			getForumCategories()
				.then((response) => {
					if (response.status === 200) {
						this.loadingCategories = false;
						this.categoriesLoaded = true;
						this.forumCategories = response.data.data;
					}
				})
				.catch((error) => {
					this.loadingCategories = false;
					this.categoriesLoaded = false;
					return error;
				});
			return true;
		}
	}
};
</script>

<style lang="scss" scoped>
.btn__grey {
	margin-right: 15px;
	margin-left: 0;
	text-transform: uppercase;
}
.btn__group {
	position: relative;
}
.loader {
	padding-left: 15px;
	position: absolute;
	bottom: -5px;
	display: inline-block;
}
.is-invalid {
	border: 1px solid #dc3545;
}
</style>
